var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        persistent: "",
        maxWidth: "90%",
        withoutCloseButton: "",
        paddingOverride: "0",
        titleRowPaddingOverride: "0"
      }
    },
    [
      _c(
        "div",
        { staticClass: "global-modal-chat-ia__corpo" },
        [
          _c("ChatView"),
          _c(
            "v-btn",
            {
              staticClass: "global-modal-chat-ia__fechar",
              attrs: { icon: "", "aria-label": "Fechar" },
              on: { click: _vm.fechar }
            },
            [
              _c("icon-svg", {
                attrs: { name: "close-circle", color: "var(--muted)", size: 30 }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }